import React, { useEffect, useRef, useState, useMemo } from "react";
import { Badge, Avatar, Button, message, Spin } from "antd";
import Styled from "styled-components";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Legend,
  ResponsiveContainer,
  LabelList,
} from "recharts";
import upload from "../../../assets/images/upload.svg";
import filtericon from "../../../assets/images/filter-svgrepo-com (1).svg";
import { Tooltip, Form, Select, DatePicker, Space, Row, Col } from "antd";
import { StyledTable } from "../../../Reusablecomponents/UITable/UITable";
import UIModal from "../../../Reusablecomponents/UIModal/index";
import { CALL_API } from "../../../Common/api";
import { handleDownloadChart } from "../../../Reusablecomponents/Export/Exportpdf";
import { useSelector } from "react-redux";
import {
  shipmentType,
  TripTypeEnum,
  PanTripTypeEnum,
} from "../../../Common/constant";
import dayjs from "dayjs";
import { CSVLink } from "react-csv";
import { pointer } from "@testing-library/user-event/dist/cjs/pointer/index.js";
import { values } from "lodash";

const Styledashboard = Styled.div`

  .head {
  margin-bottom: 5px;
    color: #5f6d8c;
    height: 29px;
    // width: 84px;
  }
  .total {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .Custom {
    display: flex;
    align-items: center;
    gap: 20px;
  }
.addwidget-btn{
  background-color: #E8FFEC;
  color:#2C963D;
  border:none;
}
.ant-card-head{
border-bottom: none;
}
.ant-modal-header {
  border-bottom: none !important;
  box-shadow: none !important;
}

.ant-modal-footer {
  border-top: none !important;
  box-shadow: none !important;
}
.rechart-legend-icon{
  width: 10px;
  height: 10px;
  border-radius: 50%;
  }
.stats-card{
   display: flex;
  flex-direction: column;
  justify-content: center; 
  align-items: center; 
  height: 100%; 
  text-align: center;
  }
  .ant-switch-checked {
  background-color: #31AB46 !important;
}
.Iconbg {
width:38px;
height:38px;
display:flex;
align-items:center;
justify-content:center;
border-radius:50%;
background-color: #EBF7ED;
}
  .dropstyle {
    margin-top: 20px !important;
    width: 251px !important;
  }
  .dropstyle1 {
    height: 36px;
    width: 251px !important;
  }
  .badg {
    padding: 5px;
    cursor: pointer;
  }
  .badg .ant-badge-count {
    font-size: 12px; 
    height: 16px; 
    min-width: 16px; 
    line-height: 16px; 
  }
  .filterstyle {
    height: 25px;
    width: 25px;
  }
  .plc .ant-select-selection-placeholder {
    color: black !important; 
  }

  .plc .ant-select-arrow {
    color: black; 
  }
    .header-container {
  display: flex;
  justify-content: space-between; 
  align-items: center; 
  width: 100%;
}
  .custom-modal {
  width: 1132px !important;
  border-radius: 12px !important;
  padding-top: 16px !important;
  padding-bottom: 16px !important;
  top: 54px !important;
}
`;

const TripAllowanceAI = () => {
  const csvLinkEl = useRef();
  const [form] = Form.useForm();
  const [tripallowwancechart, setTripallowwancechart] = useState([]);
  const [tripallowwancetable, setTripallowwancetable] = useState([]);
  const [formValues, setFormValues] = useState({});
  const [filterCount, setFilterCount] = useState(0);
  const [selectedDate, setSelectedDate] = useState(null);
  const [duration, setDuration] = useState("current_month");
  const [CSVList, setCSVList] = useState([]);
  const [CSVLoader, setCSVLoader] = useState(false);
  const userInfo = useSelector((state) => state?.authTracking?.userInfo);
  const vehicleList = useSelector((state) => state?.authTracking?.vehicleList);
  const driverList = useSelector((state) => state?.authTracking?.driverList);
  const reduxPermissions = useSelector(
    (state) => state?.authTracking?.myPermissionList || {},
  );
  const hasPermission = (seccode, action) => {
    if (!seccode || !action) return false;
    const code = seccode.toUpperCase();
    const act = action.toUpperCase();
    return (
      Array.isArray(reduxPermissions?.[code]) &&
      reduxPermissions[code].includes(act)
    );
  };
  const exportAllowed = useMemo(
    () => hasPermission("AITARPT", "EX"),
    [reduxPermissions],
  );
  const tripallowwancechartdata = async () => {
    try {
      const { data } = await CALL_API(
        "POST",
        `aiReport/tripallowance/get_tripallowance_chart?MCID=${
          userInfo.MCID
        }&startDate=${dayjs(selectedDate[0]).format(
          "YYYY-MM-DD",
        )}&endDate=${dayjs(selectedDate[1]).format("YYYY-MM-DD")}`,
        {
          Triptype: formValues.tripType || 0,
          VehId: formValues.vehicle || 0,
          Driver: formValues.driver || 0,
        },
      );
      setTripallowwancechart(data?.TripAllowanceChart || []);
    } catch (error) {
      console.error("Error fetching trip allowance chart data:", error);
    }
  };

  const tripallowwancetabledata = async () => {
    try {
      const { data } = await CALL_API(
        "POST",
        `aiReport/tripallowance/get_tripallowance_Table?MCID=${
          userInfo.MCID
        }&startDate=${dayjs(selectedDate[0]).format(
          "YYYY-MM-DD",
        )}&endDate=${dayjs(selectedDate[1]).format("YYYY-MM-DD")}        `,
        {
          TripType: formValues.tripType || 0,
          vehid: formValues.vehicle || 0,
          Driver: formValues.driver || 0,
        },
      );
      setTripallowwancetable(data?.TripAllowanceTable || []);
    } catch (error) {
      console.error("Error fetching trip allowance chart data:", error);
    }
  };

  const prepareCSV = async (event, done) => {
    try {
      setCSVLoader(true);
      const { data } = await CALL_API(
        "POST",
        `aiReport/tripallowance/get_tripallowance_Table?MCID=${
          userInfo.MCID
        }&startDate=${dayjs(selectedDate[0]).format(
          "YYYY-MM-DD",
        )}&endDate=${dayjs(selectedDate[1]).format("YYYY-MM-DD")}`,
        {
          Triptype: formValues.tripType,
          VehId: formValues.vehicle,
          Driver: formValues.driver,
        },
      );
      setCSVLoader(false);
      if (data?.TripAllowanceTable?.length > 0) {
        // Apply sorting to match table sort order
        const sortedData = applySorting(data.TripAllowanceTable || []);

        setCSVList(
          sortedData?.map((item) => ({
            "Trip Code": item.TRIPCODE || "",
            "Trip Type": item.TRIPTYPE || "",
            Vehicle: item.VEHID || "",
            "Driver Name": item.DriverName || "",
            "Started on": item.STARTED || "",
            "Trip Allowance": item.TripAllowance ?? "",
          })),
        );

        setTimeout(() => {
          csvLinkEl.current.link.click();
        });
      } else {
        message.error("No data available to download.");
      }
    } catch (error) {
      console.error("[getAssignedConsignments] error -->", error);
    }
  };

  useEffect(() => {
    tripallowwancechartdata();
    tripallowwancetabledata();
  }, [formValues, selectedDate]);

  // const consignmentchart = {
  // data: {
  //   type: 'fetch',
  //   value: 'https://gw.alipayobjects.com/os/antfincdn/iPY8JFnxdb/dodge-padding.json',
  // },

  const fields = [
    {
      label: "Vehicle",
      key: "vehicle",
      options: vehicleList.map((item) => ({
        label: item.REGNO,
        value: item.VEHID,
      })),
    },
    {
      label: "Trip Type",
      key: "tripType",
      options:
        userInfo?.MCID === 72
          ? PanTripTypeEnum?.map((item) => ({
              label: item.name,
              value: item.value,
            }))
          : TripTypeEnum?.map((item) => ({
              label: item.name,
              value: item.value,
            })),
    },
    {
      label: "Driver",
      key: "driver",
      options: driverList.map((item) => ({
        label: item.FULLNM,
        value: item.CONTACTNO,
      })),
    },
    {
      label: "Shipment Type",
      key: "shipment",
      options: shipmentType.map((item) => ({
        label: item.name,
        value: item.value,
      })),
    },
  ];

  const handleValuesChange = (value, allvalues) => {
    setFormValues(allvalues);
  };

  const getFilterCount = () => {
    const value = form.getFieldsValue() || {};
    const count = Object.values(formValues).filter(
      (val) => val && val.length !== 0,
    ).length;
    setFilterCount(count);
  };

  useEffect(() => {
    getFilterCount();
  }, [formValues]);

  const consignmentchart = {
    consignmentdata: [
      { name: "Tony Kane KC1234", TripAllowance: 1.5, FuelAllowance: 4.5 },
      { name: "Tony Kane KC1234", TripAllowance: 3.5, FuelAllowance: 2.5 },
      { name: "Tony Kane KC1234", TripAllowance: 2.5, FuelAllowance: 1.5 },
      { name: "Tony Kane KC1234", TripAllowance: 6.0, FuelAllowance: 2.5 },
      { name: "Tony Kane KC1234", TripAllowance: 3.0, FuelAllowance: 3.5 },
      { name: "Tony Kane KC1234", TripAllowance: 4.0, FuelAllowance: 1.5 },
      { name: "Tony Kane KC1234", TripAllowance: 4.5, FuelAllowance: 1.8 },
      { name: "Tony Kane KC1234", TripAllowance: 5.5, FuelAllowance: 4.5 },
      { name: "Tony Kane KC1234", TripAllowance: 6.0, FuelAllowance: 3.5 },
      { name: "Tony Kane KC1234", TripAllowance: 4.5, FuelAllowance: 6.0 },
      { name: "Tony Kane KC1234", TripAllowance: 4.7, FuelAllowance: 3.5 },
      { name: "Tony Kane KC1234", TripAllowance: 5.7, FuelAllowance: 4.5 },
    ],
  };
  const Duration = [
    { label: "Current Month", value: "current_month" },
    { label: "Current Year", value: "current_year" },
    { label: "Last Month", value: "last_month" },
    { label: "Today", value: "today" },
  ];
  const handlechange = (value) => {
    setDuration(value);
  };

  useEffect(() => {
    let startDate = null;
    let endDate = null;

    if (duration === "today") {
      startDate = dayjs();
      endDate = dayjs();
    } else if (duration === "current_month") {
      startDate = dayjs().startOf("month");
      endDate = dayjs().endOf("month");
    } else if (duration === "current_year") {
      startDate = dayjs().startOf("year");
      endDate = dayjs().endOf("year");
    } else if (duration === "last_month") {
      startDate = dayjs().subtract(1, "month").startOf("month");
      endDate = dayjs().subtract(1, "month").endOf("month");
    }

    if (startDate && endDate) {
      setSelectedDate([startDate, endDate]);
    }
  }, [duration]);

  const ConsigndeliveryChart = () => {
    return (
      <ResponsiveContainer width="100%" aspect={3}>
        <BarChart
          data={tripallowwancechart}
          margin={{ top: 60, right: 30, left: 0, bottom: 40 }}
          barCategoryGap="30%"
          barGap={4}
          style={{ cursor: "pointer" }}
        >
          <Legend
            layout="horizontal"
            align="center"
            verticalAlign="top"
            iconType="circle"
            wrapperStyle={{
              top: 10,
              fontSize: "14px",
            }}
          />
          <CartesianGrid stroke="#E0E0E0" vertical={false} />
          <XAxis
            dataKey="RegNo"
            axisLine={false}
            tickLine={false}
            interval={0}
            tick={({ x, y, payload }) => {
              const parts = payload.value.split(" ");
              const first = parts.slice(0, -1).join(" ");
              const second = parts[parts.length - 1];

              return (
                <g transform={`translate(${x},${y + 10})`}>
                  <text textAnchor="middle" fontSize={12} fill="#5F6D8C">
                    <tspan x="0" dy="0">
                      {first}
                    </tspan>
                    <tspan x="0" dy="14">
                      {second}
                    </tspan>
                  </text>
                </g>
              );
            }}
          />
          <YAxis
            axisLine={false}
            tickLine={false}
            domain={[0, 3000]}
            tickCount={13}
            tickFormatter={(value) => value.toLocaleString()}
            style={{ fontSize: 12 }}
          />
          <Tooltip />
          <Bar
            dataKey="FuelAllowance"
            name="Fuel Allowance"
            fill="#5A56E9"
            radius={[5, 5, 0, 0]}
          >
            <LabelList
              dataKey="FuelAllowance"
              content={({ x, y, width, value }) => (
                <text
                  x={x + width / 2}
                  y={y - 10} // 10px above the bar
                  fill="#000"
                  fontSize={12}
                  textAnchor="middle" // This centers the text horizontally at x
                >
                  {value}
                </text>
              )}
            />
          </Bar>
          <Bar
            dataKey="TripAllowance"
            name="Trip Allowance"
            fill="#E4A400"
            radius={[5, 5, 0, 0]}
          >
            <LabelList
              dataKey="TripAllowance"
              content={({ x, y, width, value }) => (
                <text
                  x={x + width / 2}
                  y={y - 10} // 10px above the bar
                  fill="#000"
                  fontSize={12}
                  textAnchor="middle" // This centers the text horizontally at x
                >
                  {value}
                </text>
              )}
            />
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    );
  };

  const [visible, setVisible] = useState(false);
  const [visible1, setVisible1] = useState(false);
  const handleTooltipVisibleChange = (visible) => {
    setVisible(visible);

    if (visible) {
      setTimeout(() => {
        const tooltipArrows = document.querySelectorAll(".ant-tooltip-arrow");
        tooltipArrows.forEach((arrow) => {
          arrow.style.display = "none";
        });
      }, 0);
    }
  };

  const handleTooltipVisibleChange1 = (visible) => {
    setVisible1(visible);

    if (visible) {
      setTimeout(() => {
        const tooltipArrows = document.querySelectorAll(".ant-tooltip-arrow");
        tooltipArrows.forEach((arrow) => {
          arrow.style.display = "none";
        });
      }, 0);
    }
  };

  const [isModalOpen, setIsModalOpen] = useState(false);

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleCancel = () => {
    setFormValues({});
    form.resetFields(); // Reset the form fields
    setIsModalOpen(false);
  };

  const isMobile = window.innerWidth < 600; // Detect mobile screen

  // <Pie
  //   label={!isMobile ? renderCustomizedLabel : null} // Hide labels on mobile
  // />
  const { Option } = Select;
  const { RangePicker } = DatePicker;

  const dataSource = [
    {
      key: "1",
      tripcode: "234567",
      triptype: "Safari",
      vehicle: "KA12345",
      drivername: "Tony Kensta",
      startedon: (
        <>
          <p>24th Aug 2024</p>
          <i>07:10 AM</i>
        </>
      ),
      tripallowance: "1",
    },
    {
      key: "2",
      tripcode: "234567",
      triptype: "Safari",
      vehicle: "KA12345",
      drivername: "Tony Kensta",
      startedon: (
        <>
          <p>24th Aug 2024</p>
          <i>07:10 AM</i>
        </>
      ),
      tripallowance: "1",
    },
    {
      key: "3",
      tripcode: "234567",
      triptype: "Safari",
      vehicle: "KA12345",
      drivername: "Tony Kensta",
      startedon: (
        <>
          <p>24th Aug 2024</p>
          <i>07:10 AM</i>
        </>
      ),
      tripallowance: "1",
    },
    {
      key: "4",
      tripcode: "234567",
      triptype: "Safari",
      vehicle: "KA12345",
      drivername: "Tony Kensta",
      startedon: (
        <>
          <p>24th Aug 2024</p>
          <i>07:10 AM</i>
        </>
      ),
      tripallowance: "1",
    },
    {
      key: "5",
      tripcode: "234567",
      triptype: "Safari",
      vehicle: "KA12345",
      drivername: "Tony Kensta",
      startedon: (
        <>
          <p>24th Aug 2024</p>
          <i>07:10 AM</i>
        </>
      ),
      tripallowance: "1",
    },
  ];

  const [tableSort, setTableSort] = useState({
    field: null,
    order: null, // 'ascend' or 'descend'
  });

  // Helper function to sort data based on current sort state
  const applySorting = (data) => {
    if (!tableSort.field || !data || data.length === 0) {
      return data;
    }

    const sorted = [...data].sort((a, b) => {
      let aVal = a[tableSort.field];
      let bVal = b[tableSort.field];

      // Handle numeric fields
      if (
        ["ODO", "CarbonFootprint", "LOADINGCYCLE", "OFFLOADINGCYCLE"].includes(
          tableSort.field,
        )
      ) {
        aVal = aVal || 0;
        bVal = bVal || 0;
        const result = aVal - bVal;
        return tableSort.order === "ascend" ? result : -result;
      }

      // Handle string fields
      aVal = aVal || "";
      bVal = bVal || "";
      const result = (aVal + "").localeCompare(bVal + "");
      return tableSort.order === "ascend" ? result : -result;
    });

    return sorted;
  };

  const columns = [
    {
      title: "Trip Code",
      dataIndex: "TRIPCODE",
      key: "TRIPCODE",
      sorter: (a, b) => (a.Code || "").localeCompare(b.Code || ""),
      sortOrder: tableSort.field === "Code" ? tableSort.order : null,
    },
    {
      title: "Trip Type",
      dataIndex: "TRIPTYPE",
      key: "TRIPTYPE",
      sorter: (a, b) => (a.TRIPTYPE || 0) - (b.TRIPTYPE || 0),
      sortOrder: tableSort.field === "TRIPTYPE" ? tableSort.order : null,
      render: (value) => {
        const tripType = TripTypeEnum.find((type) => type.value === value);
        return tripType ? tripType.name : "";
      },
    },
    {
      title: "Vehicle",
      dataIndex: "REGNO",
      key: "REGNO",
      sorter: (a, b) => (a.REGNO || "").localeCompare(b.REGNO || ""),
      sortOrder: tableSort.field === "REGNO" ? tableSort.order : null,
    },
    {
      title: "Driver Name",
      dataIndex: "DriverName",
      key: "DriverName",
      sorter: (a, b) => (a.DriverName || "").localeCompare(b.DriverName || ""),
      sortOrder: tableSort.field === "DriverName" ? tableSort.order : null,
    },
    {
      title: "Started on",
      dataIndex: "STARTED",
      key: "STARTED",
      sorter: (a, b) => (a.Code || "").localeCompare(b.Code || ""),
      sortOrder: tableSort.field === "Code" ? tableSort.order : null,
      render: (value) => {
        if (!value) return "N/A"; // Handle cases where the value is null or undefined

        const formattedDate = dayjs(value).format("Do MMM YYYY"); // Format date as "4th Apr 2025"
        const formattedTime = dayjs(value).format("hh:mm A"); // Format time as "HH:MM AM/PM"

        return (
          <>
            <p>{formattedDate}</p>
            <i>{formattedTime}</i>
          </>
        );
      },
    },
    {
      title: "Trip Allowance",
      dataIndex: "TripAllowance",
      key: "TripAllowance",
      sorter: (a, b) =>
        (a.TripAllowance || "").localeCompare(b.TripAllowance || ""),
      sortOrder: tableSort.field === "TripAllowance" ? tableSort.order : null,
    },
  ];
  const handlechangefordate = (date, dateString) => {
    setSelectedDate(date);
  };

  return (
    <div>
      <Styledashboard>
        <div
          className="total"
          style={{
            display: "flex",
            justifyContent: "space-between",
            width: "100%",
          }}
        >
          <div className="head">Chart View</div>
          <div className="Custom">
            <div className="dropstyle">
              {" "}
              <Form.Item
                label=""
                name="dropdown"
                rules={[
                  { required: true, message: "Please select an option!" },
                ]}
              >
                <Select
                  placeholder="Custom Range"
                  onChange={handlechange}
                  defaultValue={duration}
                  className="plc"
                >
                  {Duration.map((item) => (
                    <Option key={item.value} value={item.value}>
                      {item.label}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </div>
            <div className="dropstyle1">
              <Space direction="vertical" size={12}>
                <RangePicker
                  value={selectedDate}
                  onChange={handlechangefordate}
                />
              </Space>
            </div>
            <div>
              {/* <Tooltip
                title="Export"
                placement="bottom"
                visible={visible1}
                onVisibleChange={handleTooltipVisibleChange1}
                overlayInnerStyle={{
                  backgroundColor: "transparent",
                  color: "#5f6d8c",
                  boxShadow: "none",
                }}
              > */}
              <img
                src={upload}
                alt="Upload Icon"
                className="hover-image"
                style={{ cursor: exportAllowed ? "pointer" : "not-allowed" }}
                onClick={() => {
                  if (!exportAllowed) return;
                  handleDownloadChart("Export Chart", "Trip Allowance Chart");
                }}
              />
              {/* </Tooltip> */}
            </div>
            <div>
              <Badge count={filterCount} className="badg" onClick={showModal}>
                <Avatar
                  shape="circle"
                  size="medium"
                  src={filtericon}
                  className="filterstyle"
                />
              </Badge>
            </div>
          </div>
        </div>
        <div>
          <div style={{ width: "100%" }}>
            <div
              style={{ width: "calc(100% - 40px)", marginLeft: "20px" }}
              id="Export Chart"
            >
              <ConsigndeliveryChart />
            </div>
          </div>
        </div>
        <br />
        <div className="header-container">
          <div className="head">
            {tripallowwancetable?.length} Trip Allowance Report
          </div>
          <div>
            {/* <Tooltip
              title="Export"
              placement="bottom"
              visible={visible1}
              onVisibleChange={handleTooltipVisibleChange1}
              overlayInnerStyle={{
                backgroundColor: "transparent",
                color: "#5f6d8c",
                boxShadow: "none",
                display: "flex",
                justifyContent: "space-between",
              }}
            > */}
            <Spin spinning={CSVLoader}>
              <img
                style={{
                  cursor: exportAllowed ? "pointer" : "not-allowed",
                }}
                src={upload}
                alt="Upload Icon"
                className="hover-image"
                onClick={() => {
                  if (!exportAllowed) return;
                  prepareCSV();
                }}
              />
            </Spin>
            <CSVLink
              data={CSVList}
              filename={"Trip Break Report.csv"}
              asyncOnClick={true}
              ref={csvLinkEl}
            />
            {/* </Tooltip> */}
          </div>
        </div>
        <br />
        <div>
          {tripallowwancetable.length > 0 && (
            <StyledTable
              dataSource={tripallowwancetable}
              columns={columns}
              pagination={false}
              onChange={(pagination, filters, sorter) => {
                setTableSort({
                  field: sorter.field,
                  order: sorter.order,
                });
              }}
            />
          )}
        </div>
        <UIModal
          open={isModalOpen}
          onClose={handleCancel}
          header={
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <span>Filter({filterCount})</span>
              <span
                style={{
                  color: "#2C963D",
                  fontWeight: "400",
                  fontSize: "20px",
                  marginRight: "30px",
                }}
              >
                {filterCount} Results Found
              </span>
            </div>
          }
          footer={
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
              }}
            >
              <Button
                className="cancel-btn"
                onClick={handleCancel}
                style={{
                  borderRadius: "26px",
                  backgroundColor: "#2C963D",
                  color: "#FFFFFF",
                  borderColor: "#2C963D",
                  width: "118px",
                  height: "38px",
                }}
              >
                Cancel All
              </Button>
            </div>
          }
          closeButton={false}
          style={{
            width: "1132px",
            height: "219px",
            borderRadius: "12px",
            paddingTop: "16px",
            paddingBottom: "16px",
          }}
        >
          {/* <Form
             form={form}
             onValuesChange={(changedValues, allValues) => {
             }
             }
          
          >
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                gap: "16px",
                justifyContent: "space-between",
              }}
            >
              {[
                {
                  label: "Vehicle",
                  key: "vehicle",
                  options: ["Car", "Bike", "Bus", "Truck"],
                },
                {
                  label: "Trip Type",
                  key: "tripType",
                  options: ["One-way", "Round-trip", "Multi-city", "Rental"],
                },
                {
                  label: "Driver",
                  key: "driver",
                  options: [
                    "John Doe",
                    "Alice Smith",
                    "Michael Brown",
                    "Emily Davis",
                  ],
                },
              ].map((field) => (
                <div key={field.key} style={{ flex: 1 }}>
                  <label
                    htmlFor={field.key}
                    style={{
                      color: "#5F6D8C",
                      fontSize: "14px",
                      fontWeight: "400",
                      display: "block",
                      marginBottom: "8px",
                    }}
                  >
                    {field.label}
                  </label>
                  <select
                    id={field.key}
                    style={{
                      width: "100%",
                      padding: "8px",
                      borderRadius: "20px",
                      border: "1px solid #E7E7ED",
                      outline: "none",
                    }}
                  >
                    {field.options.map((option) => (
                      <option key={option} value={option}>
                        {option}
                      </option>
                    ))}
                  </select>
                </div>
              ))}
            </div>
          </Form> */}

          {/* <Form
            form={form}
            layout="vertical"
            onValuesChange={handleValuesChange}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                gap: "16px",
                justifyContent: "space-between",
              }}
            >
              {fields.map((field) => (
                <Form.Item
                  key={field.key}
                  name={field.key}
                  label={field.label}
                  style={{ flex: 1 }}
                >
                  <Select
                  allowClear
                    placeholder={`Select ${field.label}`}
                    style={{
                      borderRadius: "20px",
                    }}
                  >
                    {field.options.map((option) => (
                      <Select.Option key={option.value} value={option.value}>
                        {option.label}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
              ))}
            </div>
          </Form> */}
          <Form
            form={form}
            layout="vertical"
            onValuesChange={handleValuesChange}
          >
            <Row gutter={16}>
              {fields
                .filter((field) => field.key !== "shipmentType")
                .map((field, index) => (
                  <Col span={8} key={field.key}>
                    {/* Each Col with span=8 makes 3 items per row (24/8 = 3) */}
                    <Form.Item name={field.key} label={field.label}>
                      <Select
                        allowClear
                        placeholder={`Select ${field.label}`}
                        style={{ borderRadius: "20px", width: "100%" }}
                      >
                        {field.options.map((option) => (
                          <Select.Option
                            key={option.value}
                            value={option.value}
                          >
                            {option.label}
                          </Select.Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </Col>
                ))}
            </Row>

            {/* Shipment Type in separate row with increased width */}
            <Row gutter={16} style={{ marginTop: "16px" }}>
              {fields
                .filter((field) => field.key === "shipmentType")
                .map((field) => (
                  <Col span={8} key={field.key}>
                    {/* You can adjust span=12 or 24 depending on width you want */}
                    <Form.Item name={field.key} label={field.label}>
                      <Select
                        allowClear
                        placeholder={`Select ${field.label}`}
                        style={{ borderRadius: "20px", width: "100%" }}
                      >
                        {field.options.map((option) => (
                          <Select.Option
                            key={option.value}
                            value={option.value}
                          >
                            {option.label}
                          </Select.Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </Col>
                ))}
            </Row>
          </Form>
        </UIModal>
      </Styledashboard>
    </div>
  );
};

export default TripAllowanceAI;
